import { inject, Injectable } from '@angular/core';
import { FeedService } from '../api';
import { ResponseList } from '@outlaw/core';
import { Observable, of } from 'rxjs';
import { CommunityTabType, CommunityTabs } from '../../interfaces/community-tab.types';
import { FeedParams } from '../../interfaces/feed';
import { CommunityItem } from '../../interfaces/community-item';

type FeedFunction = (params: FeedParams) => Observable<ResponseList<CommunityItem>>;

@Injectable({ providedIn: 'root' })
export class FeedByCommunityTabService {
  #feedService = inject(FeedService);

  getFeedByCommunityTab(tabType: CommunityTabType): FeedFunction {
    const feeds = this.getFeedsByCommunityTab();
    return feeds[tabType];
  }

  getFeedsByCommunityTab(): Record<CommunityTabType, FeedFunction> {
    return {
      [CommunityTabs.POSTS]: this.#feedService.userFeed,
      [CommunityTabs.COMMON]: this.#feedService.commonFeed,
      [CommunityTabs.RECS]: this.#feedService.recsFeed,
      [CommunityTabs.DISCUSSIONS]: this.#feedService.userComments,
      [CommunityTabs.DISCUSSIONS_ALL]: this.#feedService.discussionsAllFeed,
      [CommunityTabs.GROUP]: this.#feedService.groupFeed,
      [CommunityTabs.GROUP_DISCUSSIONS]: this.#feedService.groupWithCommentsFeed,
      [CommunityTabs.SELECTIONS]: () => of({ list: [], pages_total: 0, total_results: 0 }),
    };
  }
}
